<template>
    <nav class="relative bg-primar-450">
      <div class="px-2" :class="!isPlatformOpen() ? 'sm:px-6 lg:px-8' : 'sm:px-2 lg:px-2' ">
        <div class="relative flex items-center justify-between h-16">
          <div class="">
            <button
                type="button"
                @click="dropdownNavMobile = !dropdownNavMobile"
                class="flex items-center justify-center h-10 w-8 text-white rounded-full hover:bg-primar-450 bg-primar-450 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white"
                :class="!isPlatformOpen() ? 'xl:hidden absolute' : '' "
                aria-controls="mobile-menu"
                aria-expanded="false"
            >
              <span class="sr-only">Open main menu</span>
              <svg
                  class="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
              >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
              <svg
                  class="hidden h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
              >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
            <div class="ml-14 2xl:ml-28">
              <img src="/images/eronto.png" alt="Eronto" class="w-40 xl:w-48">
            </div>
          </div>
          <div class="flex flex-grow items-center justify-end xl:items-stretch ">
            <div class="hidden xl:block xl:ml-6" v-if="!isPlatformOpen()">
              <div class="flex space-x-2 xl:space-x-2" >
                <div @mouseover="dropdownUserLang = false;dropdownLegal = false;dropdownTradingAcademy = false">
                  <router-link
                  to="/"
                  
                  :class="{ 'border-primar-500 text-primar-500': checkRoute('Home') }"
                  class="md:flex md:items-center text-white lg:px-2 xl:px-3 md:h-16 text-sm border-b-2 border-transparent hover:border-primar-550"
                >
                  {{ $t("navHeader.home")}}
                </router-link>
                </div>
                <a
                  @mouseover="dropdownUserLang = false;dropdownLegal = false;dropdownTradingAcademy = false"
                  :class="{ 'border-primar-500 text-primar-500': checkRoute('TradingPlatform') }"
                  href="https://my.eronto.io"
                  class="md:flex md:items-center text-white lg:px-2 xl:px-3 border-b-2 border-transparent hover:border-primar-550 hover:text-primar-400 md:h-16 text-sm"
                >
                  {{ $t("navHeader.tradingPlatform")}}
                </a>
                <div
                  class="relative"
                >
                  <button
                    type="button"
                    id="nav-menu-trading2"
                    @click="toggleSubMenuTradingAcademy()"
                    class="md:flex md:items-center text-white lg:px-2 xl:px-3 border-b-2 border-transparent hover:border-primar-550 hover:text-primar-400 focus:outline-none md:h-16 text-sm"
                    :class="{ 'border-primar-500 text-primar-450': open }"
                  >
                    {{ $t("navHeader.tradingAcademy.title")}}
                    <svg
                      class="ml-1 h-5 w-5 group-hover:text-primar-400"
                      :class="{ 'text-primar-450': open, 'text-white': !(open) }"
                      x-description="Heroicon name: solid/chevron-down"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      aria-hidden="true"
                      fill="currentColor"
                      @mouseover="dropdownUserLang = false;dropdownLegal = false"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  <div
                    class="dropdown-menu w-48 md:right-auto md:left-0 z-50 text-white border-primar-550 border-2 -mt-1"
                    v-if="dropdownTradingAcademy"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="nav-menu-trading"
                    tabindex="-1"
                  >
                    <router-link
                      to="/trading-academy/key-markets"
                      role="menuitem"
                      tabindex="-1"
                      class="hover:text-primar-400"
                    >
                      {{ $t("navHeader.tradingAcademy.keyMarket")}}
                    </router-link>
                    <hr class="h-px mx-4 border-0 bg-primar-550">
                    <router-link
                      to="/trading-academy/indicators"
                      role="menuitem"
                      tabindex="-1"
                      class="hover:text-primar-400"
                    >
                      {{ $t("navHeader.tradingAcademy.indicators")}}
                    </router-link>
                    <hr class="h-px mx-4 border-0 bg-primar-550">
                    <router-link
                      to="/trading-academy/fundamentals"
                      role="menuitem"
                      tabindex="-1"
                      class="hover:text-primar-400"
                    >
                      {{ $t("navHeader.tradingAcademy.fundamental")}}
                    </router-link>
                  </div>
                </div>
                <div @mouseover="dropdownUserLang = false;dropdownLegal = false;dropdownTradingAcademy = false">
                  <router-link
                  to="/about"
                  
                  :class="{ 'border-primar-500 text-primar-500': checkRoute('About') }"
                  class="md:flex md:items-center text-white lg:px-2 xl:px-3 border-b-2 border-transparent hover:border-primar-550 hover:text-primar-400 md:h-16 text-sm"
                >
                  {{ $t("navHeader.aboutUs")}}
                </router-link>
                </div>
                <div
                  class="relative"
                >
                  <button
                    type="button"
                    id="nav-menu-trading2"
                    @click="toggleSubMenuLegal()"
                    class="md:flex md:items-center text-white lg:px-2 xl:px-3 border-b-2 border-transparent hover:border-primar-550 hover:text-primar-400 focus:outline-none md:h-16 text-sm"
                    :class="{ 'border-primar-500 text-primar-450': open }"
                    @mouseover="dropdownUserLang = false;dropdownTradingAcademy = false"
                  >
                    {{ $t("navHeader.legal.title")}}
                    <svg
                      class="ml-1 h-5 w-5 group-hover:text-primar-400"
                      :class="{ 'text-primar-450': open, 'text-white': !(open) }"
                      x-description="Heroicon name: solid/chevron-down"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      aria-hidden="true"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  <div
                    class="dropdown-menu w-48 md:right-auto md:left-0 z-50 text-white border-primar-550 border-2 -mt-1"
                    v-if="dropdownLegal"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="nav-menu-trading"
                    tabindex="-1"
                  >
                    <router-link
                      to="/legal/terms"
                      role="menuitem"
                      tabindex="-1"
                      class="hover:text-primar-400"
                    >
                      {{ $t("navHeader.legal.termsConditions")}}
                    </router-link>
                    <hr class="h-px mx-4 border-0 bg-primar-550">
                    <router-link
                      to="/legal/privacy"
                      role="menuitem"
                      tabindex="-1"
                      class="hover:text-primar-400"
                    >
                      {{ $t("navHeader.legal.privacy")}}
                    </router-link>
                    <hr class="h-px mx-4 border-0 bg-primar-550">
                    <router-link
                      to="/legal/money"
                      role="menuitem"
                      tabindex="-1"
                      class="hover:text-primar-400"
                    >
                      {{ $t("navHeader.legal.moneyLaunderingPrevention")}}
                    </router-link>
                    <hr class="h-px mx-4 border-0 bg-primar-550">
                    <router-link
                      to="/legal/kyc"
                      role="menuitem"
                      tabindex="-1"
                      class="hover:text-primar-400"
                    >
                        {{ $t("navHeader.legal.legalDocuments")}}
                    </router-link>
                  </div>
                </div>
                <div @mouseover="dropdownUserLang = false;dropdownLegal = false;dropdownTradingAcademy = false">
                  <router-link
                  to="/contact"
                  
                  :class="{ 'border-primar-500 text-primar-500': checkRoute('Contact') }"
                  class="md:flex md:items-center text-white lg:px-2 xl:px-3 border-b-2 border-transparent hover:border-primar-550 hover:text-primar-400 md:h-16 text-sm"
                >
                  {{ $t("navHeader.contactUs")}}
                </router-link>
                </div>
                
              </div>
            </div>
          </div>
          <div class="inset-y-0 -right-2 flex items-center pr-2 sm:ml-6 sm:pr-0 2xl:mr-28">
            <div class=" lg:block relative z-50 pr-4 ml-6 xl:ml-0">
              <div>
                <button
                  type="button"
                  @click="toggleSubMenuLang"
                  @mouseover="dropdownLegal = false;dropdownTradingAcademy = false"
                  class="text-white flex items-center text-sm border-b-2 border-transparent focus:outline-none h-16"
                  id="user-menu-button-lang"
                  aria-expanded="false"
                  aria-haspopup="true"
                >
                  <span class="sr-only">Open user menu language</span>
                  <img
                    v-if="$i18n.locale == 'en' "
                    src="/images/united_kingdom-flag-rounded.png"
                    class="h-5 w-5 float-left"
                    alt="UK Flag"
                  />
                  <img
                  v-if="$i18n.locale == 'es' "
                    src="/images/spain-flag-rounded.png"
                    class="h-5 w-5 float-left"
                    alt="ES Flag"
                  />
                  <img
                  v-if="$i18n.locale == 'br' "
                    src="/images/br-flag-rounded.png"
                    class="h-5 w-5 float-left"
                    alt="BR Flag"
                  />
                  <svg
                    class="h-5 w-5 group-hover:text-white text-white"
                    :class="{ 'text-white': open, 'text-white': !(open) }"
                    x-description="Heroicon name: solid/chevron-down"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>

              <div
                class="dropdown-menu w-32 text-white bg-black border-primar-550 border-2 -mt-1"
                v-if="dropdownUserLang"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button-lang"
                tabindex="-1"
              >
                <a
                  :href="this.$route.path + '?lang=en'"
                  class="hover:text-primar-400 text-white"
                >
                  <img
                    src="/images/united_kingdom-flag-rounded.png"
                    class="h-5 w-5 float-left"
                    alt="UK Flag"
                  />&nbsp;
                  English
                </a>
                <hr class="h-px mx-4 border-0 bg-primar-550">
                <a
                  :href="this.$route.path + '?lang=es'"
                  class="hover:text-primar-400 text-white"
                >
                  <img
                    src="/images/spain-flag-rounded.png"
                    class="h-5 w-5 float-left"
                    alt="ES Flag"
                  />&nbsp;
                  Español
                </a>
                <hr class="h-px mx-4 border-0 bg-primar-550">
                <a
                  :href="this.$route.path + '?lang=br'"
                  class="hover:text-primar-400 text-white"
                >
                  <img
                    src="/images/br-flag-rounded.png"
                    class="h-5 w-5 float-left"
                    alt="BR Flag"
                  />&nbsp;
                  Português
                </a>
              </div>
            </div>
            <div class="flex items-end whitespace-nowrap">
              <a data-v-63cd6604="" href="https://my.eronto.io/register" class="cursor-pointer inline-block bg-primar-450  text-white text-sm xl:text-base py-2 px-4 rounded-md hover:bg-opacity-90 focus:outline-none focus:ring-2">
                {{ $t("navHeader.signUp")}}
              </a>

              |
              <a data-v-63cd6604="" href="https://my.eronto.io/login" class="cursor-pointer inline-block bg-primar-400 text-white text-sm xl:text-base py-2 px-4 rounded-md hover:bg-opacity-90 focus:outline-none">
                {{ $t("navHeader.signIn")}}
              </a>
            </div>
            
          </div>
        </div>
      </div>

      <div
        x-description="Mobile menu, show/hide based on menu state."
        class="shadow inset-x-0 bg-primar-450 mt-1 z-50"
        :class="!isPlatformOpen() ? 'xl:hidden' : 'absolute w-4/12'"
        id="mobile-menu"
        v-if="dropdownNavMobile"
      >
        <div class="px-2 pt-2 pb-3 space-y-1">
          <router-link
            to="/"
            class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400"
          >
            {{ $t("navHeader.home")}}
          </router-link>
          
          <a
            href="https://my.eronto.io"
            class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400"
          >
            {{ $t("navHeader.tradingPlatform")}}
          </a>
          <div
            class="relative"
          >
            <button
              type="button"
              class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 text-left outline-none w-full"
              @click="dropdownTradingAcademyMobile = !dropdownTradingAcademyMobile"
            >
              {{ $t("navHeader.tradingAcademy.title")}}
              <svg
                class="ml-1 h-5 w-5 group-hover:text-primar-400 float-right"
                x-description="Heroicon name: solid/chevron-down"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                aria-hidden="true"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
            <div
              v-if="dropdownTradingAcademyMobile"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="nav-menu-trading"
              tabindex="-1"
              class="z-50"
            >
              <router-link
                to="/trading-academy/key-markets"
                role="menuitem"
                tabindex="-1"
                class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 hover:bg-opacity-90"
              >
                {{ $t("navHeader.tradingAcademy.keyMarket")}}
              </router-link>
              <router-link
                to="/trading-academy/indicators"
                role="menuitem"
                tabindex="-1"
                class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 hover:bg-opacity-90"
              >
                {{ $t("navHeader.tradingAcademy.indicators")}}
              </router-link>
              <router-link
                to="/trading-academy/fundamentals"
                role="menuitem"
                tabindex="-1"
                class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 hover:bg-opacity-90"
              >
                {{ $t("navHeader.tradingAcademy.fundamental")}}
              </router-link>
            </div>
          </div>
          <router-link
            to="/about"
            class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400"
          >
            {{ $t("navHeader.aboutUs")}}
          </router-link>
          <div
            class="relative"
          >
            <button
              type="button"
              class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 text-left outline-none w-full"
              @click="dropdownLegalMobile = !dropdownLegalMobile"
            >
              {{ $t("navHeader.legal.title")}}
              <svg
                class="ml-1 h-5 w-5 group-hover:text-primar-400 float-right"
                x-description="Heroicon name: solid/chevron-down"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                aria-hidden="true"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
            <div
              v-if="dropdownLegalMobile"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="nav-menu-trading"
              tabindex="-1"
              class="z-50"
            >
              <router-link
                to="/legal/terms"
                role="menuitem"
                tabindex="-1"
                class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 hover:bg-opacity-90"
              >
                {{ $t("navHeader.legal.termsConditions")}}
              </router-link>
              <router-link
                to="/legal/privacy"
                role="menuitem"
                tabindex="-1"
                class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 hover:bg-opacity-90"
              >
                {{ $t("navHeader.legal.privacy")}}
              </router-link>
              <router-link
                to="/legal/money"
                role="menuitem"
                tabindex="-1"
                class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 hover:bg-opacity-90"
              >
                {{ $t("navHeader.legal.moneyLaunderingPrevention")}}
              </router-link>
              <router-link
                  to="/legal/kyc"
                  role="menuitem"
                  tabindex="-1"
                  class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400 hover:bg-opacity-90"
                >
                    {{ $t("navHeader.legal.legalDocuments")}}
                </router-link>
            </div>
          </div>
          <router-link
            to="/contact"
            class="block py-3 px-4 text-white text-sm rounded-md hover:bg-primar-400"
          >
            {{ $t("navHeader.contactUs")}}
          </router-link>
        </div>
      </div>
    </nav>
</template>
<script>
  export default {
    data() {
      return {
        dropdownUserLang: false,
        dropdownUserVisible: false,
        dropdownNavMobile: false,
        dropdownTradingAcademy: false,
        dropdownTradingAcademyMobile: false,
        dropdownLegal: false,
        dropdownLegalMobile: false,
        open: false
      }
    },
    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      console.log(this.$i18n.locale);
    },
    methods: {
      toggleSubMenuLang() {
        this.dropdownTradingAcademy = false;
        this.dropdownLegal = false;
        this.dropdownUserLang = !this.dropdownUserLang;
      },
      toggleSubMenuTradingAcademy() {
        this.dropdownUserLang = false;
        this.dropdownLegal = false;
        this.dropdownTradingAcademy = !this.dropdownTradingAcademy;
      },
      toggleSubMenuLegal() {
        this.dropdownUserLang = false;
        this.dropdownTradingAcademy = false;
        this.dropdownLegal = !this.dropdownLegal;
      },
      isPlatformOpen() {
        return this.currentRouteName === 'TradingPlatform';
      },
      checkRoute(name) {
        return this.currentRouteName == name;
      },
      changeLocale(locale) {
        localStorage.setItem('lang', locale);
        this.dropdownUserLang = false;
        this.$i18n.locale = locale;
      },
      isMobile() {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      '$route.name': {
        handler: function(search) {
           this.dropdownUserLang = false;
           this.dropdownUserVisible = false;
           this.dropdownNavMobile = false;
           this.dropdownTradingAcademy = false;
           this.dropdownTradingAcademyMobile = false;
           this.dropdownLegal = false;
           this.dropdownLegalMobile = false;
           this.open = false;
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      logo() {
        if (this.currentRouteName != 'Home') {
          return '/images/darklogo.png';
        }
        return '/images/rontonlogo.png';
      },
      currentRouteName() {
          return this.$route.name;
      }
    }
  }
</script>
<style>
</style>